module.exports = __webpack_public_path__ + "assets/img/unlock.2b8b5d3a.svg";